import { adfModelTypeMap } from './../consts/adf-model-type-map-const';

import { ILinkedServiceTypeMetadata } from 'app/extensibility/metadatas/resource-type/linked-service-type-metadata';
import { format } from 'app/shared/utils/string.util';
import { azureResourceSelectMethodOptions } from '../consts/metadata-consts';
import { AuthConstants } from 'app/services/authentication/auth-constants';
import { deprecatedConnectorDocLink } from 'app/shared/constants/links.const';

export const azureMariaDBDomain: string = AuthConstants.RESOURCE_DOMAIN_MAP[adfModelTypeMap.azureMariaDB.linkedServiceType];

export const azureMariaDBMetadata: ILinkedServiceTypeMetadata = {
    type: adfModelTypeMap.azureMariaDB.linkedServiceType,
    displayName: format(stringResources.ModelName_DisplayTextLegacyTemplate, stringResources.AzureMariaDB_DisplayText),
    linkedServiceKind: 'table',
    icon: {
        className: 'svg-i-100x100-AzureMariaDB'
    },
    warningMessage: stringResources.Connector_Legacy_IsDeprecatedWarning,
    warningMessageHyperlink: deprecatedConnectorDocLink,
    warningTooltip: stringResources.Connector_Legacy_IsDeprecatedHint,
    isFirstClass: true,
    supportDatasetV2: true,
    notShowInTypeSelection: true,
    category: ['Azure'],
    supportPE: true,
    resourceTypes: ['Microsoft.DBforMariaDB/servers'],
    peWellknowErrorMessages: [
        /Client with IP address .* is not allowed to connect to this .* server/i
    ],
    peGroupIDs: ['mariadbServer'],
    copySinkTypes: [],
    copySourceTypes: [adfModelTypeMap.azureMariaDB.copySourceType],
    controls: [
        {
            type: 'select-button-switch',
            required: true,
            isLabelVertical: true,
            options: [
                {
                    label: stringResources.ModelName_ConnectionString,
                    value: false
                },
                {
                    label: stringResources.AzureKeyVault_DisplayText,
                    value: true,
                    hideAKVOptionIfNotChosen: false
                }
            ],
            bind: 'enableAKV',
            isNotRelatedToCredential: true,
            defaultValue: false,
            cases: [
                {
                    caseValue: true,
                    children: [
                        {
                            type: 'azure-key-vault',
                            bind: 'referedAKV',
                            isLabelVertical: true
                        }
                    ]
                },
                {
                    caseValue: false,
                    children: [
                        {
                            type: 'radio-switch',
                            nested: 1,
                            label: stringResources.AccountSelectionMethodLabel,
                            description: stringResources.AzureSql_SelectMethodDescription,
                            options: azureResourceSelectMethodOptions,
                            defaultValue: '{server != null ? "manual" : "azure"}',
                            isLabelVertical: true,
                            cases: [
                                {
                                    caseValue: 'azure',
                                    children: [
                                        {
                                            type: 'azure-server-database-select',
                                            bind: {
                                                serverName: 'server',
                                                port: 'port',
                                                databaseName: 'databaseName',
                                                resourceID: '_serverResourceID'
                                            },
                                            defaultPort: '3306',
                                            showPEStatus: true,
                                            listDatabaseAPIVersion: '2018-06-01',
                                            resourceTypes: ['Microsoft.DBforMariaDB/servers'],
                                            serverDomain: azureMariaDBDomain,
                                            validators: {
                                                serverName: [
                                                    { type: 'required', errorMessage: '' }
                                                ],
                                                databaseName: [
                                                    { type: 'required', errorMessage: '' }
                                                ]
                                            }
                                        }
                                    ]
                                },
                                {
                                    caseValue: 'manual',
                                    children: [
                                        {
                                            type: 'textbox',
                                            bind: 'server',
                                            label: stringResources.FullyServerNameLabel,
                                            placeholder: `e.g., myserver.${azureMariaDBDomain}`,
                                            required: true,
                                            validators: [
                                                { type: 'required', errorMessage: '' }
                                            ],
                                            isLabelVertical: true
                                        },
                                        {
                                            type: 'textbox',
                                            bind: 'port',
                                            label: stringResources.ModelName_Port,
                                            isLabelVertical: true,
                                            inputType: 'number',
                                            min: 0
                                        },
                                        {
                                            type: 'textbox',
                                            bind: 'databaseName',
                                            label: stringResources.ModelName_DatabaseName,
                                            required: true,
                                            validators: [
                                                { type: 'required', errorMessage: '' }
                                            ],
                                            isLabelVertical: true
                                        },
                                        {
                                            type: 'private-endpoint-status'
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            type: 'textbox',
                            bind: 'userName',
                            label: stringResources.ModelName_UserName,
                            required: true,
                            validators: [
                                { type: 'required', errorMessage: '' }
                            ],
                            isLabelVertical: true
                        },
                        {

                            type: 'dynamic-akv-switcher',
                            hideAKVSwitcherInConnStrProps: true,
                            bind: 'password',
                            label: stringResources.ModelName_Password,
                            child: {
                                type: 'password',
                                label: stringResources.ModelName_Password,
                                isLabelVertical: true
                            },
                            description: format(stringResources.AzureKeyVaultSecretName_Tooltip_Template,
                                format(stringResources.ModelName_LinkedServiceTemplate, stringResources.MariaDB_DisplayText),
                                stringResources.ModelName_Password)
                        },
                        {
                            type: 'key-val-list',
                            bind: 'additionalFields',
                            label: stringResources.AdditionalConnectionStringFields
                        }
                    ]
                }
            ]
        }
    ]
};
